// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__QyvmJ","checkbox__wrapper":"Checkbox_checkbox__wrapper__3gAzi","checkbox__input":"Checkbox_checkbox__input__bKe-d"};